import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Box } from 'reflexbox/styled-components'

import styled from 'styled-components'

import theme from 'theme'
import media from 'media'

import { logoShape } from 'components/logo'
import * as logos from 'components/logo/logos'
import UniversalLink from 'components/UniversalLink'
import QuoteSvg from './assets/Quote'

export const QUOTE_ASSET_WIDTH = 34.21 // this is oddly specific cuz i didn't want to mess with the ratio from the design

const getContainerProps = ({ isSmallLogo }) => ({
  className: 'testimonial-container',
  flexWrap: isSmallLogo
    ? ['wrap', 'wrap', 'wrap', 'wrap-reverse']
    : 'wrap-reverse',
  pt: isSmallLogo ? [0] : [50],
  pb: isSmallLogo ? [0] : [64],
  px: isSmallLogo ? [0] : [0, 48, 64],
})
const Container = styled(Flex)
  .attrs(getContainerProps)
  .withConfig({
    shouldForwardProp: (prop) => ['isSmallLogo', 'inset'].indexOf(prop) === -1,
  })`
  max-width: ${theme.paperMaxWidth}px;
  margin: 0 auto;
  height: 100%;
  ${({ inset }) =>
    inset &&
    `
    box-shadow: inset 0px -22px 15px -22px rgb(0 0 0 / 8%), inset 0px 22px 15px -22px rgb(0 0 0 / 8%);
  `}
`

export const QuoteContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => ['logo', 'isSmallLogo'].indexOf(prop) === -1,
})`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  color: ${theme.colors.black};
  font-weight: ${theme.fontWeights.bold};

  ${({ logo }) =>
    !logo &&
    `
    max-width: 610px;
  `}

  ${media.desktop`
    width: 100%;
    padding: 0px;
  `}

  ${({ logo, isSmallLogo }) =>
    logo &&
    !isSmallLogo &&
    media.giant`
    width: 50%;
  `}
`

export const Quote = styled.p`
  margin-top: 50px;
  margin-bottom: 24px;
  font-size: 24px;
  font-weight: ${theme.fontWeights.normal} ${media.tablet`
    margin-bottom: 36px;
  `};

  ${media.tablet`
    font-size: 32px;
  `}

  ${media.desktop`
    font-size: 36px;
  `}
`

export const QuoteAsset = styled.div.attrs({})`
  max-width: ${QUOTE_ASSET_WIDTH}px;
  width: 100%;
  margin: 0 20px;
`

export const Quotation = styled(Flex).attrs({
  justifyContent: 'space-between',
})`
  margin: 0 auto;

  & > *:first-child {
    margin: 40px 15px 0 0;
  }

  & > *:last-child {
    align-self: flex-end;
    margin: 0 0 40px 15px;
  }
`

export const Author = styled.div`
  color: ${theme.colors.black};
  font-size: 16px;
  margin-top: 0px;
  margin-left: ${QUOTE_ASSET_WIDTH}px;
  display: none;

  ${media.desktop`
    display: block;
  `}
`

export const MobileAuthor = styled(Author)`
  display: flex;
  flex-direction: column;

  ${media.desktop`
    display: none;
  `}
`

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  text-align: center;

  ${media.giant`
    margin: 0 auto;
    padding-left: 64px;
    align-items: center;
    width: 50%;
  `}
`

export const SmallLogoContainer = styled.div``

export const AuthorReadMoreContainer = styled(Box).attrs({})``

export const LogoStyler = styled(Box).withConfig({
  shouldForwardProp: (prop) => ['isSmallLogo'].indexOf(prop) === -1,
})`
  /* THE NEW LOGOS - work to standardize logo size */
  .seso {
    height: 57px;
    width: auto;

    ${media.tablet`
      height: 75px;
    `}

    ${media.desktop`
      height: 120px;
    `}
  }

  /* OLDER LOGOS - need to upload/convert them to the new (45px high) world */

  .data-clover {
    width: ${({ isSmallLogo }) => 200 / (isSmallLogo ? 2 : 1)}px;
  }

  .flyhomes,
  .spruce-health,
  .main-street,
  .sunrise-banks {
    width: ${({ isSmallLogo }) => 250 / (isSmallLogo ? 2 : 1)}px;
  }

  .vouch,
  .newfront {
    width: ${({ isSmallLogo }) => 300 / (isSmallLogo ? 2 : 1)}px;
  }

  .flyhomes,
  .vouch,
  .spruce-health,
  .main-street,
  .sunrise-banks {
    height: ${({ isSmallLogo }) => 100 / (isSmallLogo ? 2 : 1)}px;
  }

  ${media.tablet`
    .data-clover {
      width: ${({ isSmallLogo }) => 300 / (isSmallLogo ? 2 : 1)}px;
    }

    .flyhomes,
    .newfront,
    .spruce-health,
    .main-street,
    .sunrise-banks {
      width: ${({ isSmallLogo }) => 400 / (isSmallLogo ? 2 : 1)}px;
    }

    .flyhomes,
    .vouch,
    .spruce-health,
    .main-street,
    .sunrise-banks  {
      height: ${({ isSmallLogo }) => 150 / (isSmallLogo ? 2 : 1)}px;
    }
  `}
`

export const Link = styled(UniversalLink)`
  margin-top: 0px;
  font-size: 14px;
  color: ${theme.colors.black};
  margin-left: ${QUOTE_ASSET_WIDTH}px;

  ${media.giant`
    margin-top: 0px;
    font-size: 16px;
    font-weight: ${theme.fontWeights.bold};
  `}
`

const Wrapper = styled.div.attrs({
  className: 'testimonial-wrapper',
})`
  max-width: ${theme.paperMaxWidth}px;
  margin: 0 auto;
`

export const BottomQuoteContainer = styled(Flex).attrs({
  flexDirection: ['row'],
  width: 1,
  justifyContent: 'space-between',
})``

class Testimonial extends React.Component {
  getLogo () {
    const { logo, logoName } = this.props

    let plasmicLogo
    if (logoName) {
      plasmicLogo = logos[logoName]
    }

    return plasmicLogo || logo
  }

  renderLogo () {
    const { isSmallLogo } = this.props
    const logo = this.getLogo()

    const isRenderedComponent = logo?.getImage
    const LogoComponent = logo

    return (
      <LogoStyler className={logo?.className} isSmallLogo={isSmallLogo}>
        {isRenderedComponent ? logo.getImage() : <LogoComponent />}
      </LogoStyler>
    )
  }

  render () {
    // TODO: default readMoreURL to logo.url
    const {
      children,
      author,
      title,
      readMoreURL,
      inset,
      isSmallLogo,
      quoteColor,
      readMoreText,
      ...others
    } = this.props

    const logo = this.getLogo()

    return (
      <Wrapper {...others}>
        <Container inset={inset} isSmallLogo={isSmallLogo}>
          <QuoteContainer logo={logo} isSmallLogo={isSmallLogo}>
            <Quotation>
              <QuoteAsset>
                <QuoteSvg quoteColor={quoteColor} />
              </QuoteAsset>
              <Quote>{children}</Quote>
              <QuoteAsset>
                <QuoteSvg quoteColor={quoteColor} />
              </QuoteAsset>
            </Quotation>
            <BottomQuoteContainer>
              <AuthorReadMoreContainer>
                {author && title && (
                  <>
                    <MobileAuthor>
                      <span>{author}</span>
                      <span>{title}</span>
                    </MobileAuthor>
                    <Author>
                      {author} — {title}
                    </Author>
                  </>
                )}
                {readMoreURL ? (
                  <Link to={readMoreURL}>{readMoreText} &rarr;</Link>
                ) : null}
              </AuthorReadMoreContainer>
              {logo && isSmallLogo && (
                <SmallLogoContainer>{this.renderLogo()}</SmallLogoContainer>
              )}
            </BottomQuoteContainer>
          </QuoteContainer>
          {logo && !isSmallLogo && (
            <LogoContainer>{this.renderLogo()}</LogoContainer>
          )}
        </Container>
      </Wrapper>
    )
  }
}

export const plasmicProps = {
  author: {
    type: 'string',
    defaultValue: 'John Wallace',
  },
  title: {
    type: 'string',
    defaultValue: 'Chief Insurance Office, Vouch',
  },
  readMoreURL: {
    type: 'string', // probably a URL type out there?
    defaultValue:
      '/blog/digital-transformation/insurtech-innovation-data-first',
  },
  children: {
    type: 'string',
    displayName: 'Quote',
    defaultValue:
      'The ability to use technology to manage [insurance] complexity is huge.',
  },
  logoName: {
    type: 'choice',
    defaultValue: 'vouch',
    options: Object.keys(logos),
  },
}

Testimonial.defaultProps = {
  logo: null,
  logoWidth: 350,
  inset: false,
  quoteColor: 'red',
  readMoreText: 'Read More',
}

Testimonial.propTypes = {
  logo: logoShape,
  logoWidth: PropTypes.number.isRequired,
  logoHeight: PropTypes.number,
  children: PropTypes.node.isRequired,
  readMoreURL: PropTypes.string.isRequired,
  readMoreText: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  inset: PropTypes.bool,
  quoteColor: PropTypes.string,
}

export default Testimonial
